export enum ExternalInvoicesSyncJobStatus {
  NotStarted = 'NOT STARTED',
  Retry = 'RETRY',
  UserCompleted = 'USER COMPLETED',
}
